import clsx from 'clsx';
import { UIComponent } from '../..';
import { Icon } from '../../atoms';
import { Control, Input } from '../../form';
import * as styles from './search-input.styles';

const SearchInput: UIComponent<{}, 'input'> = ({ className, ...props }) => {
  return (
    <Control className={clsx(styles.root, className)}>
      <Input className={styles.input} {...props} />
      <Icon name="search" className={styles.icon} />
    </Control>
  );
};

export default SearchInput;
